import BossModel from "@/models/BossModel";
import Element from "@/models/PlatinumPage/Version/Element/Element";
import WidgetTemplate from "@/models/PlatinumWidget/WidgetTemplate";
import Accordion from "@/models/PlatinumWidget/Accordion/Accordion";
import Information from "@/models/PlatinumWidget/Information/Information";
import Photo from "@/models/PlatinumWidget/Photo/Photo";
import Map from "@/models/PlatinumWidget/Map/Map";
import Gallery from "@/models/PlatinumWidget/Gallery/Gallery";
import HotelList from "@/models/PlatinumWidget/HotelList/HotelList";
import Video from "@/models/PlatinumWidget/Video/Video";
import Title from "@/models/PlatinumWidget/Title/Title";
import VisualLink from "@/models/PlatinumWidget/VisualLink/VisualLink";

export default class PlatinumWidget extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgets';

    static fields() {
        return {
            id: this.number(null).nullable(),
            is_prefilled: this.boolean(null),
            name_intern: this.attr(null),
            widgetable_type: this.attr(null),
            widgetable_id: this.number(null).nullable(),
            elementsCount: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            elements: this.hasMany(Element, 'platinum_widget_id'),
            template: this.belongsTo(WidgetTemplate, 'widgetable_type', 'key'),
            platinum_widget_accordion: this.belongsTo(Accordion, 'widgetable_id'),
            platinum_widget_information: this.belongsTo(Information, 'widgetable_id'),
            platinum_widget_photo: this.belongsTo(Photo, 'widgetable_id'),
            platinum_widget_map: this.belongsTo(Map, 'widgetable_id'),
            platinum_widget_gallery: this.belongsTo(Gallery, 'widgetable_id'),
            platinum_widget_hotel_list: this.belongsTo(HotelList, 'widgetable_id'),
            platinum_widget_video: this.belongsTo(Video, 'widgetable_id'),
            platinum_widget_title: this.belongsTo(Title, 'widgetable_id'),
            platinum_widget_visual_link: this.belongsTo(VisualLink, 'widgetable_id'),
        }
    }

    /**
     *
     * @param id
     * @returns {Promise<AxiosResponse<T>>}
     */
    static loadImplementations(id) {
        return this.api().action(id + '/implementations').get();
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getAll(term = '') {
        if (term.length > 0) {
            let match = new RegExp(term, "gi");
            return this.all().filter(item => item.name_intern !== null &&
                (
                    item.name_intern.match(match) ||
                    item.WidgetTemplate().name.match(match) ||
                    item.WidgetTemplate().description.match(match)
                )
            );
        }
        return this.all();
    }

    /**
     *
     * @param term
     * @returns {*}
     */
    static getPrefilled(term) {
        return this.query().where((widget) => {
            return widget.name_intern && widget.name_intern.toLowerCase().includes(term.toLowerCase())
        }).where('is_prefilled', true).get();
    }

    /**
     *
     * @param widgetableType
     * @param widgetableId
     * @returns {*}
     */
    static byWidgetable(widgetableType, widgetableId) {
        return this.all().find(item => item.widgetable_id === widgetableId && item.widgetable_type === widgetableType);
    }

    /**
     *
     * @constructor
     */
    IncreaseElementsCount() {
        this.elementsCount++;
    }

    /**
     *
     * @constructor
     */
    DecreaseElementsCount() {
        this.elementsCount--;
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    WidgetTemplate() {
        return WidgetTemplate.byKey(this.widgetable_type);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Widgetable() {
        if (this.widgetable_type !== null) {
            return this.getRelated(this.widgetable_type);
        }

        return false;
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Elements() {
        return this.getRelated('elements');
    }
}
